import {connect} from 'react-redux';
import StudentScholarships from '../components/scholarships/student-scholarships';

const mapStateToProps = (state) => ({
  collegeProfile: state.collegeProfile,
});

export default connect(mapStateToProps)(StudentScholarships);
